<template>
  <div>
    <section style="margin-left: 20px; margin-top: 10px">
      <button
        @click.prevent="onSubmit()"
        class="btn btn-danger btn-sm btn-block margin-bottom"
      >
        <i class="fa fa-search"></i> Search
      </button>

      <div v-if="errMsg != null" class="alert alert-error" id="err-alert">
        <i class="fa fa-exclamation-triangle"></i>
        <strong>Error!</strong>
        <p>{{ errMsg }}</p>
      </div>

      <div class="box box-solid">
        <div class="box-body">
          <form role="form">
            <label class="control-label text-primary">Date Range</label>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      id="dtFrom"
                      placeholder="from date"
                      autocomplete="off"
                    />
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      id="dtTo"
                      placeholder="to date"
                      autocomplete="off"
                    />
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <input v-show="false" type="text" v-model="filter.partyType" />
            <input v-show="false" type="text" v-model="filter.partyId" />

            <div
              class="form-group"
              v-if="loggedInUser && loggedInUser.role == 2"
            >
              <label class="control-label text-primary">Partners</label>
              <br />
              <input
                type="radio"
                id="partnerTair"
                value="TAIR"
                v-model="filter.partner"
              />
              TAIR
              <span>&nbsp;&nbsp;&nbsp;</span>
            </div>
            <div class="form-group" v-else>
              <label class="control-label text-primary">Partners</label>
              <br />
              <input
                type="radio"
                id="partnerTair"
                value="tair"
                v-model="filter.partner"
              />
              TAIR
              <span>&nbsp;&nbsp;&nbsp;</span>
              <input
                type="radio"
                id="partnerRep"
                value="repbase"
                v-model="filter.partner"
              />
              Repbase
              <span>&nbsp;&nbsp;&nbsp;</span>
              <input
                type="radio"
                id="partnerMor"
                value="morphobank"
                v-model="filter.partner"
              />
              MorphoBank
            </div>
            <hr style="border: 0.5px solid #efefef" />

            <div class="nav-tabs-custom">
              <ul class="nav nav-tabs">
                <li class="active">
                  <a
                    style="color: cornflowerblue"
                    href="#tab_1"
                    @click="onInstitutionTabClick"
                    data-toggle="tab"
                    >Institution</a
                  >
                </li>
                <li v-if="loggedInUser && loggedInUser.role != 'Librarian'">
                  <a
                    style="color: cornflowerblue"
                    href="#tab_2"
                    data-toggle="tab"
                    @click="filter.partyType = 'consortium'; tabType = null"
                    >Consortium</a
                  >
                </li>
                <li v-if="loggedInUser && loggedInUser.role != 'Librarian'">
                  <a
                    style="color: cornflowerblue"
                    href="#tab_3"
                    data-toggle="tab"
                    @click="
                      filter.partyType = null;
                      tabType = 'range';
                    "
                    >IP Range</a
                  >
                </li>
                <li v-if="loggedInUser && loggedInUser.role != 'Librarian'">
                  <a
                    style="color: cornflowerblue"
                    href="#tab_4"
                    data-toggle="tab"
                    @click="onActivationCodeTabClick"
                    >Activation Code</a
                  >
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="tab_1">
                  <appInstitution
                    @rowClicked="selectedInstitution = $event"
                  ></appInstitution>
                </div>
                <div class="tab-pane" id="tab_2">
                  <appConsortium
                    @rowClicked="selectedConsortium = $event"
                  ></appConsortium>
                </div>
                <div class="tab-pane" id="tab_3">
                  <div>
                    <div class="text-green" style="margin-bottom: 10px">
                      Enter multiple IP ranges, one per line. Examples for IP
                      Ranges are as follows:
                      <pre>
10.20.108.9 - 10.20.108.255
10.20.30.* - 10.20.80.*
10.20.30.*
*.*.*.* (for all IPs)
</pre
                      >
                    </div>
                    <textarea
                      class="form-control"
                      v-model="filter.ipRange"
                      rows="10"
                      placeholder="Enter IP Ranges"
                    ></textarea>
                  </div>
                </div>
                <div class="tab-pane" id="tab_4">
                  <div class="text-green" style="margin-bottom: 10px">
                    Enter Activation Code
                  </div>
                  <textarea
                    class="form-control"
                    v-model="filter.activationCode"
                    rows="2"
                    placeholder="Enter Activation Code"
                  ></textarea>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Institution from "./sections/Institution";
import Consortium from "./sections/Consortium";

export default {
  data() {
    return {
      selectedConsortium: null,
      selectedInstitution: null,
      errMsg: null,
      filteredNames: [],
      tabType: null,
    };
  },
  components: {
    appInstitution: Institution,
    appConsortium: Consortium,
  },
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
    ...mapGetters("usage", ["filter"]),
    ...mapGetters("admin", ["currUser", "allOrgs"]),
  },
  mounted() {
    console.log("UsageFilter.vue mounted.");
    console.log("Current loggedInUser object:", this.loggedInUser);
    if (this.loggedInUser) {
      console.log("Current loggedInUser role:", this.loggedInUser.role);
    } else {
      console.log("No user is logged in.");
    }
    var startDate = new Date();
    var FromEndDate = new Date();

    $(".slider-pageHitMinMax").slider();

    $("#dtFrom")
      .datepicker({
        autoclose: true,
        minViewMode: 1,
        format: "mm/yyyy",
      })
      .on("changeDate", function (selected) {
        startDate = new Date(selected.date.valueOf());
        startDate.setDate(startDate.getDate(new Date(selected.date.valueOf())));
        // $('#dtFrom').datepicker('setStartDate', startDate);

        $("#dtTo").val($("#dtFrom").val());
        $("#dtTo").datepicker("setStartDate", startDate);
      });

    $("#dtTo")
      .datepicker({
        autoclose: true,
        minViewMode: 1,
        format: "mm/yyyy",
      })
      .on("changeDate", function (selected) {
        FromEndDate = new Date(selected.date.valueOf());
        FromEndDate.setDate(
          FromEndDate.getDate(new Date(selected.date.valueOf()))
        );
        $("#dtTo").datepicker("setStartDate", startDate);
      });

    $("#err-alert").hide();

    // Load institutions and consortia on initial page render
    if (this.loggedInUser) {
      this.$store.dispatch("admin/setAllOrgs", this.loggedInUser);
      this.$store.dispatch("admin/setAllConsortia");
    }
  },
  watch: {
    loggedInUser: {
      handler: function (val, oldVal) {
        if (val != null) {
          // Re-fetch data when user becomes available (e.g., after page refresh)
          this.$store.dispatch("admin/setAllOrgs", val);
          this.$store.dispatch("admin/setAllConsortia");
        }
      },
      deep: true,
    },
  },

  methods: {
    onInstitutionTabClick() {
      console.log("Institution tab clicked");
      this.filter.partyType = "organization";
      this.tabType = null;
      // Refresh institutions list
      this.$store.dispatch("admin/setAllOrgs", this.loggedInUser);
    },
    onActivationCodeTabClick() {
      this.filter.partyType = null;
      this.tabType = "code";
    },
    updateUsageFilter() {
      if (this.tabType != "code") {
        // Check if partner is selected
        if (!this.filter.partner || this.filter.partner === "") {
          this.onErrMsg("Please select a partner.");
          return false;
        }

        if ($("#dtFrom").val() == "") {
          this.onErrMsg("From Date is required.");
          return false;
        }
        this.filter.dateFrom = $("#dtFrom").val();

        if ($("#dtTo").val() == "") $("#dtTo").val($("#dtFrom").val());

        this.filter.dateTo = $("#dtTo").val();

        var ipRange = this.filter.ipRange;
        // Clear ipRange if not the selected type, seems implied by original logic
        this.filter.ipRange = null;

        if (this.filter.partyType == "organization") {
          if (!this.selectedInstitution || !this.selectedInstitution.partyId) {
            this.onErrMsg("Please select an institution.");
            return false;
          }
          this.filter.partyId = this.selectedInstitution.partyId;
          this.filter.partyName = this.selectedInstitution.name;
        } else if (this.filter.partyType == "consortium") {
          if (!this.selectedConsortium || !this.selectedConsortium.partyId) {
            this.onErrMsg("Please select a consortium.");
            return false;
          }
          this.filter.partyId = this.selectedConsortium.partyId;
        } else {
          // IP Range case (partyType is null)
          if (!ipRange) {
            // Use the ipRange var captured earlier
            this.onErrMsg("Please enter IP Range(s).");
            return false;
          }

          if (ipRange != null && ipRange.length > 0) {
            if (ipRange.indexOf("\\n") != -1) ipRange = ipRange.split("\\n");
            if (typeof ipRange == "string") ipRange = [ipRange];
            // Assign parsed range back ONLY for this case
            this.filter.ipRange = ipRange;
          }
        }
        return true;
      } else {
        // Activation Code case
        if (!this.filter.activationCode) {
          this.onErrMsg("Please enter Activation Code.");
          return false;
        }
        // Clear other filters when activation code is used
        this.filter.partyId = null;
        this.filter.partyType = null;
        this.filter.ipRange = null;
        return true;
      }
    },
    onSubmit() {
      this.errMsg = null;
      let result = this.updateUsageFilter();
      if (result) {
        // Check specifically if the tabType is 'code' for the special dispatch
        if (this.tabType === "code") {
          this.$store.dispatch(
            "usage/getUsageByActivationCode",
            this.filter.activationCode
          );
        } else {
          // Otherwise, use the standard filter dispatch
          this.$store.dispatch("usage/setFilter", this.filter);
        }
      }
    },
    onErrMsg(msg) {
      this.errMsg = msg;
      $("#err-alert")
        .fadeTo(4000, 500)
        .slideUp(500, function () {
          $("#err-alert").slideUp(500);
        });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/paywall/usage/UsageFilter.vue